<template>
  <div v-if="localAnnouncements.length"
       :class="['general-announcement', isWarningAnnouncement && 'general-announcement__warning']">
    <div class="general-announcement__carousel">
      <div
          v-for="(announcement, index) in localAnnouncements"
          v-if="index === selectedAnnouncementIndex"
          :key="announcement.id"
      >
        <general-announcement-card
            :announcement="announcement"
            :action-button-text="chapterStudioPageConstant.READ_MORE"
            :on-action-button-click="handleReadMore"
            :is-warning-announcement="isWarningAnnouncement"
            :on-close="handleClose"></general-announcement-card>
      </div>
    </div>
    <v-layout class="announcement-control flex-grow-overwrite-all" row>
      <v-flex class="announcement-control__icon">
        <v-btn v-if="selectedAnnouncementIndex > 0" class="announcement-control__icon--btn" flat icon
               @click="handlePrevious">
          <v-icon size="12">fas fa-chevron-left</v-icon>
        </v-btn>
      </v-flex>
      <v-flex class="announcement-control__text">{{ $currentAnnouncementStateDisplay }}</v-flex>
      <v-flex class="announcement-control__icon">
        <v-btn v-if="selectedAnnouncementIndex + 1 < localAnnouncements.length" class="announcement-control__icon--btn"
               flat icon
               @click="handleNext">
          <v-icon size="12">fas fa-chevron-right</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-dialog v-model="isDetailsModalOpen"
              v-if="selectedAudienceForDetailedView"
              scrollable
              content-class="medium"
              persistent>
      <general-announcement-card
          :announcement="selectedAudienceForDetailedView"
          :is-full-view="true"
          :action-button-text="chapterStudioPageConstant.CLOSE"
          :on-action-button-click="handleCloseModal"
          :is-warning-announcement="isWarningAnnouncement"
          :on-close="handleCloseModal"></general-announcement-card>
    </v-dialog>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import { chapterStudioPageConstant } from "./chapterStudioPage.constant";
import GeneralAnnouncementCard from "@/components/ChapterStudioPage/GeneralAnnouncementCard.vue";

export default {
  name: 'GeneralAnnouncement',
  components: { GeneralAnnouncementCard },
  data() {
    return {
      chapterStudioPageConstant,
      localAnnouncements: [],
      selectedAnnouncementIndex: 0,
      isDetailsModalOpen: false,
      selectedAudienceForDetailedView: null,
    };
  },
  props: {
    announcements: {
      type: Array,
      require: true,
    },
    isWarningAnnouncement: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (this.announcements && this.announcements.length) {
      this.localAnnouncements = cloneDeep(this.announcements);
    }
  },
  computed: {
    announcementTitle() {
      return this.isWarningAnnouncement
          ? chapterStudioPageConstant.ANNOUNCEMENT_TITLE_WARNING
          : chapterStudioPageConstant.ANNOUNCEMENT_TITLE_GENERAL;
    },
    $currentAnnouncementStateDisplay() {
      if (this.localAnnouncements.length > 1) {
        return `${this.selectedAnnouncementIndex + 1} of ${this.localAnnouncements.length}`;
      }
      return null;
    },
  },
  methods: {
    handleClose(announcementId) {
      this.localAnnouncements = this.localAnnouncements.filter(anc => anc.id !== announcementId);
      this.selectedAnnouncementIndex = 0;
    },
    handlePrevious() {
      if (this.selectedAnnouncementIndex > 0) {
        this.selectedAnnouncementIndex = this.selectedAnnouncementIndex - 1;
      }
    },
    handleNext() {
      if (this.selectedAnnouncementIndex < this.localAnnouncements.length) {
        this.selectedAnnouncementIndex = this.selectedAnnouncementIndex + 1;
      }
    },
    handleReadMore(announcement) {
      this.selectedAudienceForDetailedView = announcement;
      this.isDetailsModalOpen = true;
    },
    handleCloseModal() {
      this.isDetailsModalOpen = false;
      this.selectedAudienceForDetailedView = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";
@import "../../common/styles/_commonClasses.scss";

.general-announcement {
  position: relative;
  max-width: 1115px;

  &__carousel {
    box-shadow: none;
    border-radius: 8px;
  }

  .announcement-control {
    font-size: 12px;
    font-weight: 600;
    color: $ypo-brand-blue;
    position: absolute;
    right: 10px;
    bottom: 15px;

    @include breakpointMin(sm) {
      right: 20px;
    }

    &__icon {
      width: 20px;

      &--btn {
        margin: 0;
        height: 24px;
        width: 24px;
        color: $ypo-brand-blue;
        font-weight: 600;
      }
    }

    &__text {
      padding: 3px 5px 3px;
    }
  }

  &__warning {
    .announcement-control {
      color: $ypo-error-red;

      &__icon--btn {
        color: $ypo-error-red;
      }
    }
  }
}
</style>

<style lang="scss">
.general-announcement {
  .v-carousel {
    &__prev, &__next {
      display: none !important;
    }
  }
}
</style>
